(function () {

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequired248"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequired248"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("Zsba3", function(module, exports) {

$parcel$export(module.exports, "register", function () { return $0b8b8e62c5806953$export$6503ec6e8aabbaf; }, function (v) { return $0b8b8e62c5806953$export$6503ec6e8aabbaf = v; });
$parcel$export(module.exports, "resolve", function () { return $0b8b8e62c5806953$export$f7ad0328861e2f03; }, function (v) { return $0b8b8e62c5806953$export$f7ad0328861e2f03 = v; });
var $0b8b8e62c5806953$export$6503ec6e8aabbaf;
var $0b8b8e62c5806953$export$f7ad0328861e2f03;
"use strict";
var $0b8b8e62c5806953$var$mapping = new Map();
function $0b8b8e62c5806953$var$register(baseUrl, manifest) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0b8b8e62c5806953$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0b8b8e62c5806953$var$resolve(id) {
    var resolved = $0b8b8e62c5806953$var$mapping.get(id);
    if (resolved == null) throw new Error("Could not resolve bundle with id " + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0b8b8e62c5806953$export$6503ec6e8aabbaf = $0b8b8e62c5806953$var$register;
$0b8b8e62c5806953$export$f7ad0328861e2f03 = $0b8b8e62c5806953$var$resolve;

});

parcelRegister("bCIEV", function(module, exports) {

$parcel$export(module.exports, "getBundleURL", function () { return $8765e2acac856894$export$bdfd709ae4826697; }, function (v) { return $8765e2acac856894$export$bdfd709ae4826697 = v; });
var $8765e2acac856894$export$bdfd709ae4826697;
var $8765e2acac856894$export$c9e73fbda7da57b6;
var $8765e2acac856894$export$5a759dc7a1cfb72a;
"use strict";
var $8765e2acac856894$var$bundleURL = {};
function $8765e2acac856894$var$getBundleURLCached(id) {
    var value = $8765e2acac856894$var$bundleURL[id];
    if (!value) {
        value = $8765e2acac856894$var$getBundleURL();
        $8765e2acac856894$var$bundleURL[id] = value;
    }
    return value;
}
function $8765e2acac856894$var$getBundleURL() {
    try {
        throw new Error();
    } catch (err) {
        var matches = ("" + err.stack).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^)\n]+/g);
        if (matches) // The first two stack frames will be this function and getBundleURLCached.
        // Use the 3rd one, which will be a runtime in the original bundle.
        return $8765e2acac856894$var$getBaseURL(matches[2]);
    }
    return "/";
}
function $8765e2acac856894$var$getBaseURL(url) {
    return ("" + url).replace(/^((?:https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/.+)\/[^/]+$/, "$1") + "/";
}
// TODO: Replace uses with `new URL(url).origin` when ie11 is no longer supported.
function $8765e2acac856894$var$getOrigin(url) {
    var matches = ("" + url).match(/(https?|file|ftp|(chrome|moz|safari-web)-extension):\/\/[^/]+/);
    if (!matches) throw new Error("Origin not found");
    return matches[0];
}
$8765e2acac856894$export$bdfd709ae4826697 = $8765e2acac856894$var$getBundleURLCached;
$8765e2acac856894$export$c9e73fbda7da57b6 = $8765e2acac856894$var$getBaseURL;
$8765e2acac856894$export$5a759dc7a1cfb72a = $8765e2acac856894$var$getOrigin;

});

var $cc3fb297dc83431b$exports = {};


(parcelRequire("Zsba3")).register((parcelRequire("bCIEV")).getBundleURL("cjhIC"), JSON.parse('["cjhIC","index.fbe3f492.js","bdAau","exports.7d73e01d.js","1BPiH","w3m-modal.034305a4.js","6jSKq","dist.f590e835.js","82Ugp","dist.51fd34ca.js","8ROEP","secp256k1.f5f951c8.js","712AS","ccip.be135243.js","jXDuE","dist.4295aa6b.js","gGQKo","dist.699ba042.js","1owdM","dist.b3c71f4d.js"]'));

})();
//# sourceMappingURL=index.runtime.dba90b2d.js.map
